const propertyMap = {
    "400030": "tracross",
    "400050": "parkplac",
    "400060": "traheigh",
    "400080": "glenhill",
    "400090": "villas",
    "400120": "hillcres",
    "400130": "manflats",
    "400140": "medical",
    "400160": "eusonia",
    "400170": "aspen",
    "400190": "manwest",
    "400200": "traridge",
    "400220": "capri",
    "400260": "sc1",
    "400270": "sc2",
    "400290": "spruce",
    "400330": "vita",
    "400340": "gleno1",
    "400350": "roundtre",
    "400400": "conway",
    "400410": "studio",
    "400450": "harbor",
    "400460": "porto",
    "400470": "monterey",
    "400480": "pines",
    "400530": "bellagio",
    "400540": "indigo",
    "400550": "azure",
    "400580": "riva",
    "400650": "positano",
    "400710": "carlyle",
    "400740": "harper",
    "400750": "statestr",
    "400790": "piccflat",
    "400840": "westfla1",
    "400850": "bayshore",
    "400860": "iris",
    "400890": "amalfi",
    "400900": "willfla2",
    "400930": "evergree",
    "400990": "hydepark",
    "401030": "parkland",
    "401040": "ivyflats",
    "401210": "sc3",
    "401250": "beachfl3",
    "401300": "tracourt",
    "401310": "fred",
    "401460": "sapphire",
    "401470": "celano",
    "401500": "wesley",
    "401510": "meadow",
    "401520": "beachfl1",
    "401730": "westwood",
    "401820": "brooklyn",
    "401830": "willfla1",
    "401900": "beachfl2",
    "401910": "schoofla",
    "402050": "serena",
    "402150": "westfla2",
    "402180": "palio",
    "402540": "aria",
    "401810": "olivia",
    "400100": "golfla12",
    "400510": "casa",
    "406470": "coconut",
    "407430": "mcdonald"
}

const slugMapping = {
    "amalfi": "amalfi",
    "golfside": "golfla12",
    "schooner-cove": "sc1",
    "olivia": "olivia",
    "aria-beach": "aria",
    "aspen-chase": "aspen",
    "azure": "azure",
    "bella-Capri": "capri",
    "bella-capri": "capri",
    "bella-casa": "casa",
    "bella-vita": "vita",
    "bellagio": "bellagio",
    "celano": "celano",
    "coconut-palms": "coconut",
    "Conway-Forest": "conway",
    "conway-Forest": "conway",
    "conway-forest": "conway",
    "conway": "conway",
    "evergreen": "evergree",
    "glencoe-hills": "glenhill",
    "glencoe-oaks": "gleno1", 
    "harbor-beach": "harbor",
    "hillcrest": "hillcres",
    "indigo": "indigo",
    "iris-flats": "iris",
    "manchester-flats": "manflats",
    "manchester-west": "manwest",
    "mcdonald-mansion": "mcdonald",
    "meadowbrook-village": "meadow",
    "medical-center-court": "medical",
    "monterey-lake": "monterey",
    "Palio": "palio",
    "palio": "palio",
    "park-place": "parkplac",
    "Portofino": "porto",
    "portofino": "porto",
    "Positano": "positano",
    "positano": "positano",
    "Riva": "riva",
    "riva": "riva",
    "roundtree": "roundtre",
    "sapphire": "sapphire",
    "serena": "serena",
    "spruce-knob": "spruce",
    "state-street-village": "statestr",
    "studioparc": "studio",
    "the-frederick": "fred",
    "the-pines": "pines",
    "the-villas": "villas",
    "traver-courts": "tracourt",
    "traver-crossing": "tracross",
    "traver-heights": "traheigh",
    "traver-ridge": "traridge",
    "wesley": "wesley",
    "the-wesley": "wesley",
    "bayshore": "bayshore",
    "bayshore-flats": "bayshore",
    "beach-flats": "beachfl1",
    "brooklyn-flats": "brooklyn",
    "carlyle": "carlyle",
    "carlyle-flats": "carlyle",
    "harper-flats": "harper",
    "hyde-park-flats": "hydepark",
    "ivy-flats": "ivyflats",
    "olivia": "olivia",
    "olivia-flats": "olivia",
    "schoolhouse-flats": "schoofla",
    "eusonian": "eusonia",
    "westshore-flats": "westfla1",
    "Westshore-flats": "westfla1",
    "willow": "willfla1",
    "willow-flats": "willfla1",
    "parkland": "parkland",
    "parkland-flats": "parkland",
    "westwood-suites": "westwood",
    "piccadilly-flats": "piccflat"
};

const emailBkup = {
  "amalfi": "amalfi@mckinley.com",
  "golfside": "golf@mckinley.com",
  "schooner-cove": "schoonercove@mckinley.com",
  "olivia": "oliviaflats@mckinley.com",
  "aria-beach": "ariabeach@mckinley.com",
  "aspen-chase": "aspenchase@mckinley.com",
  "azure": "azure@mckinley.com",
  "bella-Capri": "bellacapri@mckinley.com",
  "bella-capri": "bellacapri@mckinley.com",
  "bella-casa": "bellacasa@mckinley.com",
  "bella-vita": "bellavita@mckinley.com",
  "bellagio": "bellagio@mckinley.com",
  "celano": "celano@mckinley.com",
  "coconut-palms": "coconut@mckinley.com",
  "Conway-Forest": "conwayforest@mckinley.com",
  "conway-Forest": "conwayforest@mckinley.com",
  "conway-forest": "conwayforest@mckinley.com",
  "conway": "conwayforest@mckinley.com",
  "evergreen": "evergreen@mckinley.com",
  "glencoe-hills": "glencoe@mckinley.com",
  "glencoe-oaks": "glencoe@mckinley.com", 
  "harbor-beach": "harborbeach@mckinley.com",
  "hillcrest": "hillcrest@mckinley.com",
  "indigo": "indigo@mckinley.com",
  "iris-flats": "irisflats@mckinley.com",
  "manchester-flats": "manchesterflats@mckinley.com",
  "manchester-west": "manchesterwest@mckinley.com",
  "mcdonald-mansion": "glencoe@mckinley.com",
  "meadowbrook-village": "meadowbrookvillage@mckinley.com",
  "medical-center-court": "medicalcentercourt@mckinley.com",
  "monterey-lake": "monterey@mckinley.com",
  "Palio": "palio@mckinley.com",
  "palio": "palio@mckinley.com",
  "park-place": "parkplace@mckinley.com",
  "Portofino": "portofino@mckinley.com",
  "portofino": "portofino@mckinley.com",
  "Positano": "positano@mckinley.com",
  "positano": "positano@mckinley.com",
  "Riva": "riva@mckinley.com",
  "riva": "riva@mckinley.com",
  "roundtree": "roundtree@mckinley.com",
  "sapphire": "sapphire@mckinley.com",
  "serena": "serena@mckinley.com",
  "spruce-knob": "spruce@mckinley.com",
  "state-street-village": "statestreet@mckinley.com",
  "studioparc": "studioparc@mckinley.com",
  "the-frederick": "thefrederick@mckinley.com",
  "the-pines": "thepines@mckinley.com",
  "the-villas": "thevillas@mckinley.com",
  "traver-courts": "travercourts@mckinley.com",
  "traver-crossing": "travercrossing@mckinley.com",
  "traver-heights": "traverheights@mckinley.com",
  "traver-ridge": "traverridge@mckinley.com",
  "wesley": "thewesley@mckinley.com",
  "the-wesley": "thewesley@mckinley.com",
  "bayshore": "bayshoreflats@mckinley.com",
  "bayshore-flats": "bayshoreflats@mckinley.com",
  "beach-flats": "beachflats@mckinley.com",
  "brooklyn-flats": "brooklynflats@mckinley.com",
  "carlyle": "carlyleflats@mckinley.com",
  "carlyle-flats": "carlyleflats@mckinley.com",
  "harper-flats": "harperflats@mckinley.com",
  "hyde-park-flats": "hydeparkflats@mckinley.com",
  "ivy-flats": "ivyflats@mckinley.com",
  "olivia-flats": "oliviaflats@mckinley.com",
  "schoolhouse-flats": "schoolhouseflats@mckinley.com",
  "eusonian": "eusonian@mckinley.com",
  "westshore-flats": "westshoreflats@mckinley.com",
  "Westshore-flats": "westshoreflats@mckinley.com",
  "willow": "willowflats@mckinley.com",
  "willow-flats": "willowflats@mckinley.com",
  "parkland": "parklandflats@mckinley.com",
  "parkland-flats": "parklandflats@mckinley.com",
  "westwood-suites": "westwoodsuites@mckinley.com",
  "piccadilly-flats": "piccadillyflats@mckinley.com"
};


export default propertyMap;

export const getYardiPropId = (rmpropid) => propertyMap[rmpropid];

export const getYardiPropIdFromSlug = (slug) => slugMapping[slug];

export const getEmailBkup = (slug) => emailBkup[slug] || 'live@mckinley.com';